export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-x-ce11dc7e2be5b9b26cd45e95ab316297.svg";